import tippy from 'tippy.js'
import $ from 'jquery'

$(() => {
  tippy('[data-tippy-content]', {
    allowHTML: true,
    interactive: true
  })
})
